import { render } from "./B.vue?vue&type=template&id=40556778"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/B.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40556778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40556778', __exports__)) {
    api.reload('40556778', __exports__)
  }
  
  module.hot.accept("./B.vue?vue&type=template&id=40556778", () => {
    api.rerender('40556778', render)
  })

}


export default __exports__